import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Footer } from './Footer';
import { ShieldCheck } from 'lucide-react';
export function ClosingSection() {
  return <section className="pt-24 pb-10 px-4 bg-cream watermark-bg" data-id="element-6">
      <div className="max-w-3xl mx-auto text-center" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-8">
          {/* Guarantee Badge */}
          <div className="inline-flex flex-col items-center mb-10" data-id="element-9">
            <div className="w-28 h-28 rounded-full bg-gold/10 border-2 border-gold/30 flex items-center justify-center mb-4 relative" data-id="element-10">
              <ShieldCheck className="w-14 h-14 text-gold" data-id="element-11" />
              <div className="absolute -bottom-1 bg-gold text-navy text-[10px] font-bold tracking-wider uppercase px-3 py-1 rounded-full" data-id="element-12">
                30 Days
              </div>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-13">
            My 30-Day
            <br className="hidden md:block" data-id="element-14" /> "Peace of Mind" Guarantee.
          </h2>

          <p className="text-xl text-navy/70 leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-15">
            If this framework doesn't give you clarity within 30 days, I don't
            want your money. Email me for a 100% refund.{' '}
            <span className="text-gold font-semibold" data-id="element-16">
              You keep the peace, I take the risk.
            </span>
          </p>

          <CTAButton mainText="YES, I WANT CLARITY NOW — $17.95" large hidePriceAnchor data-id="element-17" />
        </motion.div>
      </div>

      <Footer data-id="element-18" />
    </section>;
}